export const ANALYTICS_CONTAINER_ID = {
    G2C: process.env.GOTO_ANALYTICS_CONTAINER_ID,
    G2R: process.env.RESOLVE_ANALYTICS_CONTAINER_ID,
    LMIPRO: process.env.LMIPRO_ANALYTICS_CONTAINER_ID,
    LMICENTRAL: process.env.LMICENTRAL_ANALYTICS_CONTAINER_ID,
}
